module.exports=__LANG;